import { Box, Tooltip } from "@mui/material";
import { LockOutlined } from "@mui/icons-material";

export const CONFIDENTIAL_ACCESS_NAME = "Can Access Confidential Information";

/** The Secure Exchange role of a client user; a lock marks Confidential Access,
 * which only exists under it. */
export default function SecureExchangeRoleLabel({
  confidential,
  iconSize,
}: {
  confidential: boolean;
  iconSize: number;
}) {
  return (
    <Box
      component="span"
      sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}
    >
      Secure Exchange
      {confidential ? (
        <Tooltip title={CONFIDENTIAL_ACCESS_NAME}>
          <Box component="span" role="img" sx={{ display: "inline-flex" }}>
            <LockOutlined sx={{ fontSize: iconSize }} />
          </Box>
        </Tooltip>
      ) : null}
    </Box>
  );
}
